<template>
	<div class="card">
		<p class="date">发布日期：{{dateAndWeek}}</p>
		<div class="content">
			<p class="title text-ellipsis">
				{{homeworkInfo.title}}
			</p>
			<p>
				<label>发 布 人：</label>{{homeworkInfo.createByName}}
			</p>
			<p>
				<label>截止日期：</label>{{homeworkInfo.endTime}}
			</p>
			<div class="btns flex between">
				<p :style="{color:colors[homeworkInfo.status]}" class="flex">{{completionStatusText}}</p>
				<button v-if="homeworkInfo.status == 0" @click="toDetails" class="test">去完成</button>
				<button v-else-if="homeworkInfo.status == 1" @click="toDetails" class="details">查看详情</button>
				
			</div>
		</div>
	</div>
</template>

<script>
import { getWeek } from "@/utils/date.js";
export default {
	props:{
		homeworkInfo:{}
	},
	computed:{
		dateAndWeek(){
			let time = this.homeworkInfo.releaseTime;
			return time?.split(" ")[0] + ' ' + getWeek(time);
		},
		completionStatusText(){
			let completionStatus = this.homeworkInfo.completionStatus; //0-待完成，1-已完成
			let status = this.homeworkInfo.status;
			// return status==2?'已结束':['待完成','已完成'][completionStatus]
			return ['待完成','已完成','已结束'][status];
		},
		showDoneBtn(){
			return this.homeworkInfo.status==1&&this.homeworkInfo.completionStatus==0;
		},
	},
	data() {
		return {
			colors:[
				'rgba(242, 65, 19, 1)',
				'rgba(255, 162, 22, 1)',
				'rgba(255, 162, 22, 1)',
				// 'rgba(169 169 169, 1)'
			]
		};
	},
	methods: {
		toDetails() {
			this.$router.push(`/student/course/grade/homework/details?homeworkId=${this.homeworkInfo.id}`);
		},
	},
};
</script>

<style lang="less" scoped>
.card {
	padding: 0 17/@rem;
	p.date {
		font-size: 10/@rem;
		color: rgba(31, 30, 29, 0.3);
		padding: 17/@rem 0 12/@rem;
	}
	.content {
		box-shadow: 0 3/@rem 17/@rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12/@rem;
		padding: 14/@rem 11/@rem;
		p {
			padding-bottom: 11/@rem;
			font-size: 14/@rem;
			color: rgba(31, 30, 29, 0.6);
			label {
				display: inline-block;
				width: 75/@rem;
				text-align: justify;
				text-align-last: justify;
				/*兼容ie*/
				text-justify: distribute-all-lines;
				white-space: nowrap;
			}
			&.title {
				width: 100%;
				font-size: 17/@rem;
				color: rgba(31, 30, 29, 1);
				span:first-child {
					flex: 1;
					font-size: 17/@rem;
					font-family: Source Han Sans CN-Medium;
					font-weight: bold;
					letter-spacing: 1/@rem;
				}
			}
		}
		.btns {
			p{
				flex: 1;
				height: 33/@rem;
				padding:  0 11/@rem;
				font-weight: bold;
				letter-spacing: 1/@rem;
				background-color: rgba(255, 246, 233, 1);
				border-radius: 15/@rem;
			}
			button {
				width: 88/@rem;
				height: 28/@rem;
				border-radius: 15/@rem;
				color: white;
				margin-left: 10/@rem;
				&.details {
					background-color: rgba(254, 198, 51, 1);
				}
				&.test {
					background-color: rgba(255, 162, 22, 1);
				}
			}
		}
	}
}
</style>
